var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-mark",class:{
            'check-mark_active': _vm.localValue === true,
            'check-mark_disabled': _vm.disabled,
            'check-mark_mobile': _vm.$vuetify.breakpoint.xsOnly
        },on:{"click":function($event){return _vm.changeMark()}}},[(!_vm.loading)?_c('i',{staticClass:"v-icon mdi mdi-check"}):_vm._e(),(_vm.loading)?_c('i',{staticClass:"v-icon mdi mdi-loading check-mark__loading"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }